import { isDevEnv } from '@/utils/index';

export class Logger {
  info() {
    isDevEnv && console.info(...arguments);
  }
  log() {
    isDevEnv && console.log(...arguments);
  }
  error() {
    isDevEnv && console.error(...arguments);
  }
  warn() {
    isDevEnv && console.warn(...arguments);
  }
  table() {
    isDevEnv && console.table(...arguments);
  }
  debug() {
    isDevEnv && console.debug(...arguments);
  }
  groupCollapsed() {
    isDevEnv && console.groupCollapsed(...arguments);
  }
  groupEnd() {
    isDevEnv && console.groupEnd();
  }
}

export const logger = new Logger();
